module.exports = __webpack_public_path__ + "static/media/price-guarantee.4ac90862.svg";